module.exports = __webpack_public_path__ + "img/bg-right.ebf16d95.png";